import { RiDownloadLine } from '@remixicon/react';
import { AgDropdownItem, AgDropdownMenu, AgDropdownSeparator } from 'src/components/ui';
import { exportGrid, useGridExportState } from 'src/hooks/useGridExport';

type ExportGridButtonProps = {
  optionsComponent?: React.ReactNode;
  canPrint?: boolean;
  /** Test id forwarded to the export trigger button. */
  'data-testid'?: string;
  /** Test id for the Excel menu item. */
  excelTestId?: string;
  /** Test id for the CSV menu item. */
  csvTestId?: string;
  /** Test id for the Print menu item. */
  printTestId?: string;
};

export default function ExportGridButton({
  optionsComponent = null,
  canPrint = true,
  'data-testid': dataTestId,
  excelTestId,
  csvTestId,
  printTestId,
}: ExportGridButtonProps) {
  const gridIsExporting = useGridExportState((s) => s.isExporting);

  return (
    <AgDropdownMenu
      variant="white"
      size="sm"
      isDisabled={gridIsExporting}
      icon={<RiDownloadLine size={16} />}
      data-testid={dataTestId}
      items={
        <>
          {optionsComponent}
          {!!optionsComponent && <AgDropdownSeparator />}
          <AgDropdownItem onAction={() => exportGrid('excel')} data-testid={excelTestId}>
            Excel
          </AgDropdownItem>
          <AgDropdownItem onAction={() => exportGrid('csv')} data-testid={csvTestId}>
            CSV
          </AgDropdownItem>
          {canPrint && (
            <AgDropdownItem onAction={() => exportGrid('print')} data-testid={printTestId}>
              Print
            </AgDropdownItem>
          )}
        </>
      }
    >
      Export
    </AgDropdownMenu>
  );
}
